import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';

import { ISS_AUTH_GUARD } from './auth.config';

export const isAuthenticatedGuard: CanActivateFn = (route, state) => inject(ISS_AUTH_GUARD)(route, state);
